import {
  CAMERA_2D_FAR,
  CAMERA_2D_NEAR,
  CONTROLS_3D_SMOOTH,
  CONTROLS_DOLLY_SPEED,
  PAN_ACTION,
} from '@constants'
import { useCachedCamera3D } from '@hooks/useCachedCamera3D'
import { useCameraControls3D } from '@hooks/useCameraControls3D'
import { CameraControls, OrthographicCamera } from '@react-three/drei'
import { useAppStore } from '@store'

export function CameraManagerAlzados() {
  // const camera3DPosition = useAppStore((store) => store.camera3DData.position)
  const isModalOpen = useAppStore.use.isModalOpen()
  const { controlsRef } = useCameraControls3D()
  useCachedCamera3D()
  // const editCameraBoundingBox = useAppStore.use.editCameraBoundingBox()
  // const cameraObjectRef = useRef(null)
  // const cameraOBB = useAppStore.use.cameraOBB()
  // const sceneBoundingBoxes = useAppStore.use.sceneBoundingBoxes()
  // const editWall = useAppStore.use.editWallProperty()
  // const items = useAppStore.use.items()
  const camera2DPosition = useAppStore.use.camera2DPosition().position
  const camera2DZoom = useAppStore.use.camera2DPosition().zoom

  // const { raycaster } = useThree()

  // useFrame(() => {
  //   if (
  //     !cameraObjectRef.current ||
  //     !cameraOBB ||
  //     !raycaster ||
  //     !raycaster.camera ||
  //     !raycaster.camera.position ||
  //     !raycaster.camera.rotation ||
  //     location.href.includes('openProject') ||
  //     location.href.includes('downloading')
  //   ) {
  //     return
  //   }

  //   consoleOnce('looking for camera position', {
  //     pos: raycaster.camera.position,
  //     rot: raycaster.camera.rotation,
  //   })

  //   editCameraBoundingBox(raycaster.camera.position, raycaster.camera.rotation)

  //   for (const [OBBID, itemOBB] of sceneBoundingBoxes.entries()) {
  //     const wallInfo = items.get(OBBID)

  //     if (!wallInfo) continue
  //     // console.log(itemOBB, 'itemobb')
  //     const intersects = cameraOBB.intersectsOBB(itemOBB.boundingBox)
  //     // console.log('los intersects', intersects)

  //     if (intersects) {
  //       startTransition(() => {
  //         editWall(OBBID, { visible: false, wallVisible: false })
  //       })
  //     } else {
  //       startTransition(() => {
  //         editWall(OBBID, { visible: true, wallVisible: true })
  //       })
  //     }

  //     if (!wallInfo.visible) {
  //       startTransition(() => {
  //         editWall(OBBID, { y: 0 })
  //       })
  //     }
  //   }
  // })
  //TODO:necesito setear lastView en la store al pasar al mode_idle
  //y setear la camara en lastView con setPosition y moveTo al pasar a mode_3d_view
  return (
    <group>
      {/* <PerspectiveCamera
        makeDefault
        frustumCulled={false}
        ref={cameraObjectRef}
        up={[0, 1, 0]}
        position={camera3DPosition}
        near={CAMERA_3D_NEAR}
        far={CAMERA_3D_FAR}
        fov={CAMERA_3D_FOV}
      /> */}
      <OrthographicCamera
        makeDefault
        key={`${camera2DZoom}AlzadosCamera`}
        frustumCulled
        zoom={camera2DZoom}
        near={CAMERA_2D_NEAR}
        far={CAMERA_2D_FAR}
        position={camera2DPosition}
      />
      <CameraControls
        makeDefault
        ref={controlsRef}
        infinityDolly={true}
        smoothTime={CONTROLS_3D_SMOOTH}
        dollySpeed={CONTROLS_DOLLY_SPEED}
        // minDistance={CONTROLS_3D_MIN_DISTANCE}
        //* Desactiva la rotación
        mouseButtons-left={PAN_ACTION}
        enabled={!isModalOpen}
      />
    </group>
  )
}
